import { BaseComponent } from '../../base-component';
import { OnlineMarketingData } from '../server';
import { trackAdjust } from '@otto-ec/apps-api/thirdpartytracking';
import { exactag } from '@otto-ec/online-marketing/exactag';

export class OnlineMarketingComponent extends BaseComponent {
    public rootSelector = '.js_pdp_online-marketing';

    private isInitialVariationChange = true;

    public async init(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        const onlineMarketingData = this.getOnlineMarketingData();
        OnlineMarketingComponent.registerExactagDataProviderCallback(onlineMarketingData);
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        if (this.isInitialVariationChange) {
            this.isInitialVariationChange = false;
            const onlineMarketingData = this.getOnlineMarketingData();
            OnlineMarketingComponent.trackFirebase(onlineMarketingData);
            await this.trackAdjust(onlineMarketingData);
        }
    }

    private async trackAdjust(onlineMarketingData: OnlineMarketingData) {
        return trackAdjust({
            eventName: {
                android: 'afdtak',
                ios: 'xm6d1x',
            },
            partnerParameters: {
                articleids: '["' + onlineMarketingData.articleNumber + '"]',
                contentType: 'product',
                sitePath: window.location.href,
            },
        });
    }

    private getOnlineMarketingData(): OnlineMarketingData {
        return JSON.parse(this.getChildElement('.js_pdp_online-marketing__dataJson').innerHTML);
    }

    private static registerExactagDataProviderCallback(onlineMarketingData: OnlineMarketingData) {
        try {
            exactag.registerVerticalDataCallback('productDetailPage', () => {
                const pb = onlineMarketingData.averageRatingRounded
                    ? String(onlineMarketingData.averageRatingRounded)?.replace('.', ',')
                    : undefined;
                return {
                    pt: 'Artikeldetailseite',
                    mp: onlineMarketingData.articleNumber,
                    mv: onlineMarketingData.variationId,
                    pr: onlineMarketingData.isSale ? 1 : 0,
                    pb,
                };
            });
        } catch (_ignore) {
            /*         */
        }
    }

    private static trackFirebase(onlineMarketingData: OnlineMarketingData) {
        o_global.eventQBus.emit('ft-apps.firebase.eventTracking', {
            event_name: 'view_item',
            event_params: {
                item_id: onlineMarketingData.articleNumber,
                item_name: onlineMarketingData.name,
                item_category: onlineMarketingData.businessCategory,
            },
        });
    }
}
